/**
 * FinMaple Color Tokens v1.0
 * Single source of truth for the entire palette.
 * Import from here — never hardcode hex values in components.
 */
export const colors = {
  primary:       '#1E3A5F',
  primaryHover:  '#1A3152',
  primaryLight:  '#2E4F7A',
  accent:        '#D32F2F',
  accentHover:   '#B71C1C',

  success:       '#2E7D32',
  warning:       '#F9A825',
  warningText:   '#7D5A00',
  error:         '#C62828',

  textPrimary:   '#1A1A1A',
  textSecondary: '#5F6B7A',
  border:        '#E6E9EE',
  bgSoft:        '#F7F9FC',
  bgHover:       '#EEF0F3',
  bgCard:        '#FFFFFF',

  successTint:   '#E8F5E9',
  warningTint:   '#FFF8E1',
  errorTint:     '#FFEBEE',
  primaryTint:   'rgba(30,58,95,0.06)',
};
